// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_20kri","locked":"index_locked_3tdQf"};